import { combineReducers } from 'redux';
import { authReducer } from './account.reducers';

export default combineReducers({
	authentication: authReducer,
});

// Present app state structure:
/*

{
    authentication: {
        isAuthenticated: boolean;
    }
}

*/



// WEBPACK FOOTER //
// ./src/reducers/index.ts